import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import Input from "../Input";
import { regex, required } from "../../utils/validation";
import { v4 as uuidv4 } from "uuid";
import { UiAddList } from "./AddList.style";
/**
 * 可新增刪除項目列表
 */

const AddList = ({
  data = [],
  onChange,
  validator
}) => {
  const [value, setValue] = useState("");
  const [message, setMessage] = useState("");

  const addItemHandle = () => {
    let isPass = true;
    isPass = required(value);
    if (validator) isPass = regex(value, validator);

    if (!isPass) {
      setMessage("輸入的格式不正確！");
      return;
    }

    const newList = [...data, value];
    onChange(newList);
    setValue("");
  };

  const removeHandle = reItem => {
    const newList = data.filter(item => item !== reItem);
    onChange(newList);
  };

  const onKeyEnter = e => {
    let isPass = true;
    isPass = required(value);
    if (validator) isPass = regex(value, validator);

    if (!isPass) {
      setMessage("輸入的格式不正確！");
      return;
    }

    const newList = [...data, value];
    onChange(newList);
    setValue("");
  };

  const onInputChange = e => {
    const value = e.target.value;
    setValue(value);
    setMessage("");
  };

  return /*#__PURE__*/React.createElement(UiAddList, null, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("span", null, "\u9805\u76EE"), /*#__PURE__*/React.createElement("span", null, "\u522A\u9664")), data.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      className: "item",
      key: uuidv4()
    }, /*#__PURE__*/React.createElement("span", null, item), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      name: "disabled_by_default",
      onClick: () => removeHandle(item)
    })));
  }), /*#__PURE__*/React.createElement("div", {
    className: "input"
  }, /*#__PURE__*/React.createElement(Input, {
    onChange: onInputChange,
    value: value,
    onKeyEnter: onKeyEnter,
    message: message
  }), /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "add",
    onClick: addItemHandle
  }))));
};

export default AddList;
AddList.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  validator: PropTypes.any
};